import { connect } from 'react-redux';
import React from 'react';
import routerActions from 'app/routerActions';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import * as valid from 'utils/validate';
import { api, apiUtils } from 'app/services';
import {
getCitiesAction,
locationActions,
getProvincesAction,
apiCallFailure } from
'app/actions';
import {
KBInput,
KBSelect,
KBButton,
KBTextarea,
KBUserInput,
KBPopover,
KBPopoverTop,
KBForm,
KBMorePhotoUpload } from
'components';
import {
LOCATION_TYPES,
CAN_BINDING_CARD,
CAN_SET_TOUCH_PASSWORD,
DISPLAY_BLUETOOTH_LOCK } from
'app/constants';
import LocationProviderForm from './LocationProviderForm';
import { ADD_LOCATION } from 'app/constants/hint';
import * as selectors from 'app/selectors';
import { arrayToObject } from 'utils/kbUtil';
import { showApiError } from 'utils/feedback';

var LocationForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.createLocation = this.createLocation.bind(this);this.getAddressTrapeze = this.getAddressTrapeze.bind(this);this.addressCallback = this.addressCallback.bind(this);this.getCities = this.getCities.bind(this);this.addLocationProvider = this.addLocationProvider.bind(this);this.providerField = this.providerField.bind(this);this.createField = this.createField.bind(this);this.createArrayField = this.createArrayField.bind(this);this.renderHiddenField = this.renderHiddenField.bind(this);}getInitialState()
  {
    return {
      location_stores: [],
      location_members: this.props.location_members || [],
      trapeze: null };

  }createLocation(
  model) {
    const { successCallBack, space_members } = this.props;
    model.public = 'false';
    const { manager_id, operator_ids } = model;

    delete model.manager_id;
    delete model.operator_ids;
    let roles = [];
    if (manager_id) {
      roles.push({
        role: 'location_manager',
        range: 'all',
        user_ids: [manager_id] });

    }

    if (operator_ids) {
      roles.push({
        role: 'location_operator',
        range: 'all',
        user_ids: operator_ids ? operator_ids.split(',') : [] });

    }

    model.roles = roles;

    return api.createLocation(model).then(json => {
      successCallBack && successCallBack(json);
      this.props.createLocationAction.success(json);
      // this.props.callBack();
      KBPopover.close();
      this.props.callBack && this.props.callBack();
    }).catch(error => {
      showApiError(error);
    });
  }componentDidMount()
  {
    api.getCities().then(
    json => {
      this.props.getCitiesAction.success(json);
    },
    errors => {
      this.props.getCitiesAction.failure(errors);
    });

    api.getProvinces().then(
    json => {
      this.props.getProvincesAction.success(json);
    },
    errors => {
      this.props.getProvincesAction.failure(errors);
    });

    api.getLocationStores().then(json => {
      let location_stores_list = json.json;
      let location_stores = [];
      location_stores_list &&
      location_stores_list.map(stores => {
        location_stores.push({
          id: stores.id,
          name: stores.location_name });

      });
      this.setState({
        location_stores });

    });
  }getAddressTrapeze(

  city, address) {
    return apiUtils.
    _apiGetTrapezeOfGaode(city, address).
    then(({ json }) => {
      if (json.geocodes.length == 0) {
        return false;
      }
      let geoCodes = json.geocodes[0];
      let trapeze = geoCodes.location;
      let trapezeArray = trapeze.split(',');
      this.props.change('longitude', trapezeArray[0]);
      this.props.change('latitude', trapezeArray[1]);

      this.setState({
        trapeze,
        showLongitude: trapezeArray[0],
        showLatitude: trapezeArray[1] });

      return trapeze;
    }).
    then(trapeze => {
      this.setState({ trapeze });
    });
  }addressCallback(

  e) {
    const province_id = this.createField('province_id');
    const city_id = this.createField('city_id');
    if (city_id.value == '') {
      return null;
    } else if (city_id.value == '-1') {
      return null;
    }
    let value = e.target.value;
    this.props.change('physical_address', value);
    let cities = this.getCities(province_id);
    let cityName = cities[city_id.value].name;
    value && this.getAddressTrapeze(cityName, value);
  }getCities(

  province_id) {
    const citiesArray = this.props.cities.filter(
    json => json.province_id == province_id.value);

    const cities = arrayToObject(citiesArray);
    return cities;
  }addLocationProvider()

  {
    KBPopoverTop.show(<LocationProviderForm callBack={this.providerField} />);
  }providerField(

  provider) {
    const location_providers = this.props.formValues.location_providers || [];
    this.props.change('location_providers', location_providers.concat({
      info: provider.info,
      contact_name: provider.contact_name,
      contact_phone: provider.contact_phone,
      contact_email: provider.contact_email,
      account_bank: provider.account_bank,
      account_name: provider.account_name,
      account_number: provider.account_number }));
  }createField(

  name) {
    const { change, formValues = {}, formFieldMeta = {}, formSyncErrors = {} } = this.props;
    const fieldMeta = formFieldMeta[name] || {};
    return {
      value: formValues[name],
      touched: !!fieldMeta.touched,
      error: formSyncErrors[name],
      onChange: value => {
        const nextValue = value && value.target ? value.target.value : value;
        change(name, nextValue);
      } };

  }createArrayField(

  name) {
    const { change, formValues = {} } = this.props;
    const value = formValues[name] || [];
    const field = value.map((item, index) => {
      const result = {};
      Object.keys(item || {}).forEach(key => {
        result[key] = {
          value: item[key],
          onChange: nextValue => {
            const currentValue = nextValue && nextValue.target ? nextValue.target.value : nextValue;
            const nextArray = value.map((arrayItem, itemIndex) =>
            itemIndex === index ? { ...arrayItem, [key]: currentValue } : arrayItem);
            change(name, nextArray);
          } };

      });
      return result;
    });
    field.addField = item => change(name, value.concat(item));
    field.removeField = index => change(
    name,
    value.filter((item, itemIndex) => itemIndex !== index));

    return field;
  }renderHiddenField(

  { input }) {
    return <input {...input} type="hidden" />;
  }render()

  {
    const {
      error,
      handleSubmit,
      submitting,
      hideOther,
      devices,
      locationGroups,
      group } =
    this.props;
    const name = this.createField('name');
    const location_type = this.createField('location_type');
    const serial_number = this.createField('serial_number');
    const prefix = this.createField('prefix');
    const city_id = this.createField('city_id');
    const location_providers = this.createArrayField('location_providers');
    const priority = this.createField('priority');
    const location_store_id = this.createField('location_store_id');
    const province_id = this.createField('province_id');
    const images = this.createField('images');
    const display_bluetooth_lock = this.createField('display_bluetooth_lock');
    const can_set_touch_password = this.createField('can_set_touch_password');
    const can_binding_card = this.createField('can_binding_card');
    const district_id = this.createField('district_id');
    const physical_address = this.createField('physical_address');
    const size = this.createField('size');
    const telephone = this.createField('telephone');
    const description = this.createField('description');
    const manager_id = this.createField('manager_id');
    const operator_ids = this.createField('operator_ids');
    const device_ids = this.createField('device_ids');
    const price_range = this.createField('price_range');
    const location_group_id = this.createField('location_group_id');
    const { trapeze, location_stores } = this.state;
    const hint = ADD_LOCATION;
    const citiesArray = this.props.cities.filter(
    json => json.province_id == province_id.value);

    const cities = arrayToObject(citiesArray);
    const provinces = this.props.provinces;
    const city = cities && cities[city_id.value];
    const districts = city && city.districts || [];
    let locationsList = group ?
    locationGroups.filter(item => item.id == group.id) :
    locationGroups.filter(item => item.locations.length > 0);
    // const group_id = group && group.id ? group.id : null
    // locationGroups && locationGroups.map((item, index) => {
    //   if (item.locations.length > 0) {
    //     locationsList.push(item)
    //   }
    // })

    return (
      <KBForm onSubmit={handleSubmit(this.createLocation)}>
        {[
        'name',
        'location_type',
        'serial_number',
        'prefix',
        'city_id',
        'longitude',
        'latitude',
        'display_bluetooth_lock',
        'can_binding_card',
        'can_set_touch_password',
        'district_id',
        'province_id',
        'physical_address',
        'size',
        'priority',
        'location_store_id',
        'telephone',
        'image',
        'images',
        'description',
        'manager_id',
        'operator_ids',
        'public',
        'device_ids',
        'location_providers',
        'price_range',
        'location_group_id'].
        map(name => (
          <Field key={name} name={name} component={this.renderHiddenField} />
        ))}

        {hideOther ?
        '' :

        <header className="kb-form-header">
            <h2 className="header-title">添加新分店</h2>
            <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

          </header>}

        <div
        className="kb-form-container"
        ref={ref => {
          this.locationScroll = ref;
        }}>

          <fieldset className="fieldset">
            <legend>基本信息</legend>
            <div className="kb-row kb-form-84">
              <KBInput
              className="kb-form-group kb-div-210"
              title="分店名称"
              isRequired={true}
              hint={hint.name}
              field={name}
              fistFoucs={true} />

              <KBInput
              className="kb-form-group kb-div-48"
              title="编号"
              hint={hint.number}
              field={serial_number}
              titleClass="label-rt" />

            </div>
            <div className="kb-row  kb-form-84">
              {group && group.id ?
              <KBUserInput
              title="所属项目"
              placeholder="选择项目"
              className="kb-form-group kb-div-210"
              field={location_group_id}
              disabled={true}
              users={locationsList}
              selectedUsers={locationsList.filter(lg => lg.id == group.id)} /> :


              <KBUserInput
              title="所属项目"
              placeholder="选择项目"
              className="kb-form-group kb-div-210"
              field={location_group_id}
              multi={false}
              users={locationsList}
              selectedUsers={[]} />}


              <KBInput
              className="kb-form-group kb-div-48"
              isRequired={true}
              title="项目前缀"
              hint="用于合同和订单编号的生成"
              field={prefix}
              titleClass="label-rt" />

            </div>
            <div className="kb-row">
              <KBSelect
              title="分店类型"
              defaultValue={'-1'}
              className="kb-form-group kb-form-c18 kb-form-alone"
              field={location_type}
              arrayData={LOCATION_TYPES} />

            </div>
            <div className="kb-row kb-form-84">
              <div className="kb-form-66">
                <KBSelect
                defaultValue={'-1'}
                className="kb-form-group kb-div-48"
                isRequired={true}
                title="省份"
                field={province_id}
                arrayData={provinces} />

                <KBSelect
                defaultValue={'-1'}
                className="kb-form-group kb-div-48"
                isRequiredR={true}
                title="城市"
                titleClass="label-rt"
                field={city_id}
                arrayData={cities} />

              </div>
              {districts.length != 0 ?
              <KBSelect
              defaultValue={'-1'}
              className="kb-form-group kb-div-48"
              isRequiredR={false}
              titleClass="label-rt"
              title="区"
              field={district_id}
              arrayData={districts} /> :


              <div></div>}

            </div>
            <div className="kb-row" style={{ position: 'relative' }}>
              <div className="kb-form-group kb-form-c18 kb-form-alone">
                <label>
                  地址<span className="must-fill">*</span>
                </label>
                <div>
                  <textarea
                  className={`${
                  physical_address.touched && physical_address.error ?
                  'kb-input-error' :
                  'kb-input'
                  }`}
                  onChange={this.addressCallback}
                  style={{
                    height: 140,
                    paddingRight: 210,
                    paddingBottom: 20 }} />


                  {physical_address.touched && physical_address.error ?
                  <p className="lr-error f-left">{physical_address.error}</p> :

                  ''}

                </div>
              </div>
              {trapeze ?
              <img
              src={`https://restapi.amap.com/v3/staticmap?markers=-1,http://oausa5585.bkt.clouddn.com/IconLOCAL@2x.png,0:${trapeze}&key=${process.env.REACT_APP_AMAP_KEY || ''}&zoom=17&scale=1`}
              style={{
                position: 'absolute',
                right: 1,
                top: 30,
                height: 138,
                width: 138 }} /> :



              ''}

            </div>
            <div className="kb-row kb-form-66">
              <KBInput
              className="kb-form-group kb-form-210"
              hint={hint.tel}
              field={telephone}
              title="电话" />

              <KBInput
              className="kb-form-group kb-form-210"
              hint={hint.area}
              isRequired={true}
              inputClass="input-area"
              field={size}
              title="面积"
              titleClass="label-rt" />

            </div>
            <div className="kb-row kb-form-66">
              <KBInput
              className="kb-form-group kb-form-210"
              hint={'请输入价格范围的描述'}
              field={price_range}
              title="价格范围" />

              <KBInput
              className="kb-form-group kb-form-210"
              hint={'请输入数字，修改客户端的社区位置，数字越大排上面'}
              field={priority}
              title="排序位"
              titleClass="label-rt" />

            </div>
            <div className="kb-row">
              <KBSelect
              defaultValue=" "
              className="kb-form-group kb-div-c18 kb-form-alone"
              title="Location store"
              field={location_store_id}
              arrayData={location_stores} />

            </div>
            {location_type.value === 'self_office' ||
            location_type.value === 'sales_office' ? null :
            <div>
                <div className="kb-row">
                  <KBUserInput
                title="设备"
                className="kb-form-group kb-form-c18 kb-form-alone"
                field={device_ids}
                placeholder="选择设备"
                multi={true}
                users={devices} />

                </div>
                <div className="kb-row">
                  <KBSelect
                defaultValue=" "
                className="kb-form-group kb-div-c18 kb-form-alone"
                title="自行绑卡"
                field={can_binding_card}
                arrayData={CAN_BINDING_CARD} />

                </div>
                <div className="kb-row">
                  <KBSelect
                defaultValue=" "
                className="kb-form-group kb-div-c18 kb-form-alone"
                title="触摸密码"
                field={can_set_touch_password}
                arrayData={CAN_SET_TOUCH_PASSWORD} />

                </div>
                <div className="kb-row">
                  <KBSelect
                defaultValue=" "
                className="kb-form-group kb-div-c18 kb-form-alone"
                title="蓝牙门禁"
                field={display_bluetooth_lock}
                arrayData={DISPLAY_BLUETOOTH_LOCK} />

                </div>
                <div className="kb-row">
                  <KBTextarea
                className="kb-form-group kb-form-c18 kb-form-alone"
                hint={hint.intro}
                field={description}
                placeholder="输入简介"
                title="简介" />

                </div>
              </div>}

          </fieldset>
          {location_type.value === 'self_office' ||
          location_type.value === 'sales_office' ? null :
          <fieldset className="fieldset">
              <legend>收款账户信息</legend>
              {location_providers.length > 0 &&
            location_providers.map((provider, index) => {
              return (
                <div
                className="location-provider"
                style={{ marginBottom: 10 }}>

                      <span
                  className="operate-provider delete-provider"
                  onClick={() => {
                    location_providers.removeField(index);
                  }}>

                        <i className="iconfont icon-delete" />
                      </span>
                      <div className="provider-line">
                        <div>
                          <span>账户信息</span>
                          <span>{provider.info.value || '暂无'}</span>
                        </div>
                      </div>
                      <div className="provider-line">
                        <div>
                          <span>账户开户行</span>
                          <span>{provider.account_bank.value || '暂无'}</span>
                        </div>
                      </div>
                      <div className="provider-line">
                        <div>
                          <span>账户名</span>
                          <span>{provider.account_name.value || '暂无'}</span>
                        </div>
                        <div>
                          <span>账号</span>
                          <span>{provider.account_number.value || '暂无'}</span>
                        </div>
                      </div>
                      <div
                  className="provider-line"
                  style={{ marginBottom: 0 }}>

                        <div>
                          <span>联系人</span>
                          <span>{provider.contact_name.value || '暂无'}</span>
                        </div>
                        <div>
                          <span>联系方式</span>
                          <span>{provider.contact_phone.value || '暂无'}</span>
                        </div>
                      </div>
                    </div>);

            })}
              <button
            type="button"
            className="bordered-btn"
            style={{ marginLeft: 0, marginTop: 10 }}
            onClick={this.addLocationProvider}>

                添加收款账户信息
              </button>
            </fieldset>}

          <fieldset className="fieldset">
            <legend>管理公司</legend>
            <div className="kb-row">
              <KBUserInput
              title="负责人"
              className="kb-form-group kb-form-c18 kb-form-alone"
              hint={hint.principal}
              isRequired={true}
              field={manager_id}
              multi={false}
              users={this.props.space_members}
              selectedUsers={this.state.location_members} />

            </div>
            <div className="kb-row">
              <KBUserInput
              title="员工"
              className="kb-form-group kb-form-c18 kb-form-alone"
              hint={hint.staff}
              isRequired={true}
              field={operator_ids}
              multi={true}
              users={this.props.space_members}
              selectedUsers={this.state.location_members} />

            </div>
          </fieldset>
          <div className="kb-row" style={{ textAlign: 'left' }}>
            <KBMorePhotoUpload
            uploadedText={`点击 x 继续上传`}
            hint="允许多张上传,格式为png或jpg,大小不大于10M"
            photoShow={true}
            sort={true}
            className="kb-form-group kb-form-alone"
            field={images}
            text="上传图片"
            accept=".png,.jpg"
            imgStyle={{ width: '232px', height: '134px', marginBottom: 10 }}
            isPublic />

          </div>
          {hideOther ?
          <KBButton
          className="certain-btn"
          style={{ display: 'none' }}
          type="submit"
          submitting={submitting}
          id="locationFormButton">

              确定
            </KBButton> :

          <div className="kb-row fixed-form-btn">
              <span className="cancel-btn" onClick={KBPopover.close}>
                取消
              </span>
              <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}
            id="locationFormButton">

                确定
              </KBButton>
            </div>}

        </div>
      </KBForm>);

  }};


function mapStateToProps(state, props) {
  const cities = selectors.getCitiesToArray(state);
  const provinces = selectors.getProvinces(state);
  const devices = selectors.getDevices(state);
  const locationGroups = selectors.getLocationGroups(state);
  const selector = formValueSelector('LocationForm');
  const formValues = selector(
  state,
  'name',
  'location_type',
  'serial_number',
  'prefix',
  'city_id',
  'longitude',
  'latitude',
  'display_bluetooth_lock',
  'can_binding_card',
  'can_set_touch_password',
  'district_id',
  'province_id',
  'physical_address',
  'size',
  'priority',
  'location_store_id',
  'telephone',
  'image',
  'images',
  'description',
  'manager_id',
  'operator_ids',
  'public',
  'device_ids',
  'location_providers',
  'price_range',
  'location_group_id') || {};
  return {
    space_members: selectors.getSpaceUsers(state),
    cities,
    provinces,
    devices,
    locationGroups,
    formValues,
    formFieldMeta: state.form &&
    state.form.LocationForm &&
    state.form.LocationForm.fields ||
    {},
    formSyncErrors: state.form &&
    state.form.LocationForm &&
    state.form.LocationForm.syncErrors ||
    {} };

}

function mapDispatchToProps(dispatch) {
  return {
    getCitiesAction: bindActionCreators(getCitiesAction, dispatch),
    getProvincesAction: bindActionCreators(getProvincesAction, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    createLocationAction: bindActionCreators(locationActions.create, dispatch),
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

const validate = values => {
  const errors = {};

  if (valid.required(values.name)) {
    errors.name = '请输入分店名称';
  }

  // if(values.telephone&&valid.mobile(values.telephone)){
  //   errors.telephone = '请输入正确的手机号码'
  // }

  if (valid.required(values.size)) {
    errors.size = '请输入分店面积';
  }
  if (valid.required(values.prefix)) {
    errors.prefix = '请输入项目前缀';
  }
  if (valid.required(values.physical_address)) {
    errors.physical_address = '请输入分店地址';
  }

  if (valid.required(values.province_id)) {
    errors.province_id = '请选择省份';
  }

  if (valid.required(values.city_id)) {
    errors.city_id = '请选择城市';
  }

  // if(valid.required(values.district_id)){
  //   errors.district_id = '请选择城市区域'
  // }

  if (valid.required(values.operator_ids)) {
    errors.operator_ids = '请选择至少一位运营成员';
  }

  if (valid.required(values.manager_id)) {
    errors.manager_id = '请选择至少一位负责人';
  }

  if (valid.Float(values.longitude)) {
    errors.longitude = '请输入正确格式';
  }

  if (valid.Float(values.latitude)) {
    errors.latitude = '请输入正确格式';
  }

  if (values.priority && valid.Int(values.priority)) {
    errors.priority = '排序只能输入数字';
  }

  return errors;
};

const formConfig = {
  form: 'LocationForm',
  validate: validate,
  touchOnBlur: false,
  enableReinitialize: true };

LocationForm = reduxForm(formConfig)(LocationForm);

export default connect(mapStateToProps, mapDispatchToProps)(LocationForm);
